import React from "react";

interface H4SpacingLetterProps {
  children: any;
  className?: string;
}

const H4SpacingLetter: React.FC<H4SpacingLetterProps> = ({
  children,
  className,
}) => {
  return (
    <h4
      className={`text-lg text-gray-500 tracking-custom font-medium ${className ?? ''}`}
    >
      {children}
    </h4>
  );
};

export default H4SpacingLetter;
